import type { ComponentType, SVGProps } from 'react'

import { cn } from 'lib/utils'

import { iconMap } from './iconMap'
import type { IconName } from './iconMap'

import './index.scss'

const mainClass = 'icon'

interface IconProps {
  name: IconName | string
  className?: string
  width?: number
  height?: number
  isColor?: boolean
}

const resolveIconName = (name: IconName | string): IconName | null => {
  if (name in iconMap) {
    return name as IconName
  }
  return null
}

const getIconComponent = (
  name: IconName
): ComponentType<SVGProps<SVGSVGElement>> | null => {
  return iconMap[name] ?? null
}

export const Icon = ({
  name,
  className = '',
  width,
  height,
  isColor = false,
}: IconProps) => {
  const resolvedName = resolveIconName(name)
  if (!resolvedName) {
    return null
  }

  const IconComponent = getIconComponent(resolvedName)
  if (!IconComponent) {
    return null
  }

  return (
    <span
      className={cn(mainClass, className, {
        [`${mainClass}--color`]: isColor,
      })}
      aria-hidden="true"
    >
      <IconComponent width={width} height={height} />
    </span>
  )
}
